import React from 'react';
import './App.css';
import Main from "./components/main/index.tsx";

function App() {
  return (
      <div id={"container"}>
        <Main />
      </div>
  );
}

export default App;
